import React, {useState, useEffect} from 'react';
import Table from './table/table.component';

function TableEvents(props) {



  const [data, setData] = useState([]);
  //this function is for the  filter categories.
  const filterCategory = (rows, id, filterValue) => {
    
    if(filterValue[0] === 'all_events') return rows;

    return rows.filter(row => { 
      const rowValue = row.values[id].toLowerCase();
      return filterValue.includes(rowValue);
    })
  }


 
  useEffect(() => {
    //console.log('isFiltered', props.isFiltered)
    
    if(props.isFiltered) {
      const filteredData = props.dateFiltersData.length > 0 ? props.dateFiltersData : [];
      setData(filteredData)
    }
    else {
  
      setData(props.eventsData)
    }
    }, [props.dateFiltersData, props.eventsData])



      const columns = React.useMemo(
          () => [
            {
              Header: () => null,
              accessor: 'place', // accessor is the "key" in the data
              Cell: ({ cell: { value } }) => <p style={{fontSize: "20px",
              fontFamily: "Montserrat, sans-serif", fontWeight: "600",
              color: "#DC251A", marginLeft: '25px', marginTop: "7px", marginBottom: "7px",
           
          
              }}>{value}</p>
            },
            {
              Header: () => null,
              accessor: 'eventDate',
            },
            {
              Header: () => null,
              accessor: 'id',
            },
            {
              Header: () => null,
              accessor: 'eventDescription',
            },
            {
              Header: () => null,
              accessor: 'eventType',
              filter: filterCategory
            },
          ],
          []
        );
 
        const groupBy = ['place']; 
        const hiddenColumns = ['eventDate', 'eventDescription', 'eventType'];
 
    return (
        <Table
            columns={columns} 
            data={data} 
            groupColumn={groupBy} 
            hiddenColumns={hiddenColumns}
            filtersData = {props.filtersData}
            onEventClick={props.onEventClick}
            onDateData={props.dateFiltersData}
        />
    );
}
 
export default TableEvents;
